import React, { Component } from "react";
import "../../styles/Organization.css";
import orgCard from "../../images/Espotz-Banner.png";
import orgLogo from "../../images/image75.png";
import OrganizationApis from "../../helper/organization.api";
import { ellipsis, errorHandler, getWebData } from "../../utils/common.utils";
import MatchesApis from "../../helper/matches.api";
import TeamApis from "../../helper/teams.api";
import { profile } from "../../utils/localstorage.utils";
import bioIcon from "../../images/icon/bio-icon.png";
import { Modal } from "react-bootstrap";
import ConfirmationModal from "../popup/ConfirmationModal";
import { toast } from "react-toastify";
import OrgIcon from "../../images/icon/orgIcon";

class Organization extends Component {
  organizationApi = new OrganizationApis();
  authUser = profile();
  constructor() {
    super();
    this.state = {
      organizations: [],
      orgDetailsFetched: false,
      bioLimit: 100,
      discordModal: false,
      confirm: null,
    };

    this.matchesApis = new MatchesApis();
    this.teamApi = new TeamApis();
  }
  componentDidMount() {
    const data = {
      msg: this.discordMsg(),
      key: "",
    };
    this.setState({ confirm: data });
    this.props.showOrHideNav(true);
    this.getData();
  }

  setWebsiteData = res => {
    console.log("website response", res);
    this.setState({ websiteData: res[0] });
  };

  getData() {
    this.props.updateLoader(true);
    this.organizationApi
      .getOrganizations()
      .then(res => {
        var data = res.data["result"];
        this.setState({
          organizations: data,
        });
        this.setState({ orgDetailsFetched: true });
        this.props.updateLoader(false);
      })
      .catch(err => {
        this.setState({ orgDetailsFetched: true });
        this.props.updateLoader(false);
        errorHandler(err, this.props.logout);
      });
  }

  createOrganization = () => {
    if (profile()?.block) {
      toast.warning("You cannot perform this action as you are blocked by Espotz Admin");
      return false;
    }
    if (!this.authUser?.isEmailVerified) {
      this.props.openPolicies(true);
      return;
    }
    this.props.history.push("/organization/create");
    // if (profile()?.discordProfile?.discordUsername) {
    //   this.props.history.push("/organization/create");
    // } else {
    //   this.setState({ discordModal: true });
    // }
  };

  createOrganizationBtn = () => {
    return (
      <div className="row justify-content-center">
        <div className="col-12 col-md-6 col-lg-3">
          <div className="d-grid my-4">
            <button
              className="create-clan-button pink-skyblue-gradient-btn flat-btn wallet-btn fw-bold py-2 px-4 text-white border-0"
              onClick={this.createOrganization}
            >
              Create Organization
            </button>
          </div>
        </div>
      </div>
    );
  };

  getStartedBtn = () => {
    return (
      <button
        type="button"
        className="btn btn-primary btn-lg fw-bold px-4 py-3"
        onClick={this.createOrganization}
        style={{
          background: "linear-gradient(45deg, #4a90e2 0%, #67b26f 100%)",
          border: "none",
          borderRadius: "12px",
          boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
          transition: "transform 0.2s, box-shadow 0.2s",
        }}
        onMouseOver={e => {
          e.currentTarget.style.transform = "translateY(-2px)";
          e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,0,0,0.25)";
        }}
        onMouseOut={e => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 4px 15px rgba(0,0,0,0.2)";
        }}
      >
        Create Organization
      </button>
    );
  };

  discordMsg = () => {
    return (
      <p className="fs-14 fw-600 text-center text-white">
        You haven't connected to discord,click yes to connect
      </p>
    );
  };

  checkOrgStatus = el => {
    if (el.block) {
      toast.warning("This organization is currently blocked by Espotz admin");
      return false;
    }
    this.props.history.push(`/organization/view/${el._id}`);
  };

  getOrganizationsList = organizations => {
    const requiredObject = getWebData();

    if (this.state.orgDetailsFetched) {
      // When no organization available
      if (this.state.organizations?.length === 0) {
        return (
          <div
            className="empty-state-container d-flex flex-column align-items-center justify-content-center py-5"
            style={{
              minHeight: "70vh",
              position: "relative",
              overflow: "hidden",
            }}
          >
            {/* Main content */}
            <div className="text-center px-4" style={{ position: "relative", zIndex: 1 }}>
              <div className="row justify-content-center">
                <div className="col-12 col-lg-8">
                  <h1
                    className="display-4 fw-bold text-white mb-3 fs-40"
                    style={{
                      textShadow: "0 2px 4px rgba(0,0,0,0.3)",
                    }}
                  >
                    Welcome to Organizations
                  </h1>

                  <p
                    className="text-white-50 mb-5 fs-18 fw-400"
                    style={{
                      maxWidth: "600px",
                      margin: "0 auto",
                      lineHeight: "1.6",
                    }}
                  >
                    Create or join an organization to manage tournaments, host events, and build
                    your gaming community.
                  </p>

                  <div className="d-grid gap-3" style={{ maxWidth: "300px", margin: "0 auto" }}>
                    {this.getStartedBtn()}

                    <p className="text-white-50 mt-3 mb-0 fs-14 fw-400">
                      Start your journey today and build your gaming legacy!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      }
      // When One organization available
      else if (this.state.organizations?.length === 1) {
        var organizations = this.state.organizations.map((el, i) => {
          return (
            <div
              className="col-12 col-md-6 col-lg-12 my-2 clanPage_Cards"
              key={i}
              onClick={() => this.checkOrgStatus(el)}
            >
              <div className="cursor-pointer" key={i}>
                <div
                  className={`card organizationCard mb-3 ${
                    el.isOrganizationActive ? "" : "epz-clan-deactivate"
                  }`}
                >
                  <img
                    src={el?.coverImage?.url ? el.coverImage.url : orgCard}
                    alt="..."
                    className="orgCardImage"
                    style={{ height: "130px" }}
                  />
                  {el.isOrganizationActive ? null : <p className="deactivated">Deactivated</p>}
                  <div className="row px-3 pb-3 pt-1">
                    <div className="col-4 col-md-4 col-lg-2">
                      {el?.logo?.url ? (
                        <img
                          src={el.logo?.url}
                          className="logo-card position-absolute rounded-15 ms-lg-5"
                          alt=""
                          style={{ top: "90px" }}
                        />
                      ) : (
                        <div
                          className="logo-card position-absolute rounded-15 ms-lg-5"
                          style={{
                            top: "90px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            overflow: "hidden",
                          }}
                        >
                          <OrgIcon
                            color="#ffffff"
                            size="100%"
                            style={{
                              padding: "10px",
                              background: "linear-gradient(to bottom, #f55d5d 0%, black 100%)",
                            }}
                          />
                        </div>
                      )}
                    </div>
                    <div className="col-8 col-md-8 col-lg-10">
                      <h5 className="fs-20 fs-lg-24 fw-600 text-white ms-1 ms-md-2 ms-lg-4 text-truncate">
                        {el?.name}
                      </h5>
                      <p className="fs-16 fs-lg-20 fw-600 text-white ms-1 ms-md-2 ms-lg-4 text-truncate">
                        {el?.liveTournamentCount} Live Tournaments
                      </p>
                    </div>
                    <div className="col-12 col-lg-11 m-auto">
                      <span className="d-flex align-items-center mb-1">
                        <img src={bioIcon} className="ms-1 mb-1" alt="" style={{ width: "20px" }} />
                        <p className="fs-14 fw-600 ms-2 mb-0 text-white">Bio</p>
                      </span>
                      <p
                        className="bio-ContentSetting text-white rounded-10 fw-500 fs-14"
                        style={{
                          textAlign: "justify",
                          overflowWrap: "break-word",
                        }}
                      >
                        {el?.bio}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        });
        return (
          <div className="row justify-content-center px-3">
            <h1 className="fs-20 fs-lg-24 fw-bold text-white">Organizations</h1>
            {this.createOrganizationBtn()}
            <p className="fs-14 fs-lg-18 fw-500 text-white-50">
              {requiredObject.INFORMATION_TEXT?.CLAN_ORG?.ORG_DESCRIPTION}
            </p>
            {organizations}
          </div>
        );
      }
      // When Two organization available
      else if (this.state.organizations?.length === 2) {
        var organizations = this.state.organizations.map((el, i) => {
          return (
            <div
              className="col-12 col-md-6 col-lg-6 my-2 clanPage_Cards"
              key={i}
              onClick={() => this.checkOrgStatus(el)}
            >
              <div className="cursor-pointer" key={i}>
                <div
                  className={`card organizationCard mb-3 ${
                    el.isOrganizationActive ? "" : "epz-clan-deactivate"
                  }`}
                >
                  <img
                    src={el?.coverImage?.url ? el.coverImage.url : orgCard}
                    alt="..."
                    className="orgCardImage"
                  />
                  {el.isOrganizationActive ? null : <p className="deactivated">Deactivated</p>}
                  <div className="row px-3 pb-3 pt-1">
                    <div className="col-4 col-md-4">
                      {el?.logo?.url ? (
                        <img
                          src={el?.logo?.url ? el.logo?.url : orgLogo}
                          className="logo-card position-absolute rounded-15"
                          alt=""
                        />
                      ) : (
                        <div
                          className="logo-card position-absolute rounded-15"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            overflow: "hidden",
                          }}
                        >
                          <OrgIcon
                            color="#ffffff"
                            size="100%"
                            style={{
                              padding: "10px",
                              background: "linear-gradient(to bottom, #f55d5d 0%, black 100%)",
                            }}
                          />
                        </div>
                      )}
                    </div>
                    <div className="col-8 col-md-8">
                      <h5 className="fs-16 fs-lg-20 fw-600 text-white text-truncate">{el?.name}</h5>
                      <p className="fs-12 fs-lg-16 fw-600 text-white mb-2">
                        {el?.liveTournamentCount} Live Tournaments
                      </p>
                    </div>
                    <div className="col-12 col-lg-11 m-auto">
                      <span className="d-flex align-items-center mb-1">
                        <img src={bioIcon} className="ms-1 mb-1" alt="" style={{ width: "20px" }} />
                        <p className="fs-14 fw-600 ms-2 mb-0 text-white">Bio</p>
                      </span>
                      <p
                        className="bio-ContentSetting fs-14 fw-normal text-white-50 rounded-10 mb-1"
                        style={{
                          textAlign: "justify",
                          overflowWrap: "break-word",
                          height: "110px",
                        }}
                      >
                        {ellipsis(el.bio, 100)}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        });
        return (
          <div className="row justify-content-center px-3">
            <h1 className="fs-20 fs-lg-24 fw-bold text-white">Organizations</h1>
            {this.createOrganizationBtn()}
            <p className="fs-14 fs-lg-18 fw-500 text-white-50">
              {requiredObject.INFORMATION_TEXT?.CLAN_ORG?.ORG_DESCRIPTION}
            </p>
            {organizations}
          </div>
        );
      }
      // When multiple organization available
      else {
        var organizations = this.state.organizations.map((el, i) => {
          return (
            <div
              className="col-12 col-md-6 col-lg-4 my-2 clanPage_Cards"
              key={i}
              onClick={() => this.checkOrgStatus(el)}
            >
              <div className="cursor-pointer" key={i}>
                <div
                  className={`card organizationCard mb-3 ${
                    el.isOrganizationActive ? "" : "epz-clan-deactivate"
                  }`}
                >
                  <img
                    src={el?.coverImage?.url ? el.coverImage.url : orgCard}
                    alt="..."
                    className="orgCardImage"
                  />
                  {el.isOrganizationActive ? null : <p className="deactivated">Deactivated</p>}
                  <div className="row px-3 pb-3 pt-1">
                    <div className="col-4 col-md-4">
                      {el?.logo?.url ? (
                        <img
                          src={el?.logo?.url ? el.logo?.url : orgLogo}
                          className="logo-card position-absolute rounded-15"
                          alt=""
                        />
                      ) : (
                        <div
                          className="logo-card position-absolute rounded-15"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            overflow: "hidden",
                          }}
                        >
                          <OrgIcon
                            color="#ffffff"
                            size="100%"
                            style={{
                              padding: "10px",
                              background: "linear-gradient(to bottom, #f55d5d 0%, black 100%)",
                            }}
                          />
                        </div>
                      )}
                    </div>
                    <div className="col-8 col-md-8">
                      <h5 className="fs-16 fs-lg-20 fw-600 text-white text-truncate">{el?.name}</h5>
                      <p className="fs-12 fs-lg-16 fw-600 text-white mb-2">
                        {el?.liveTournamentCount} Live Tournaments
                      </p>
                    </div>
                    <div className="col-12 col-lg-11 m-auto">
                      <span className="d-flex align-items-center mb-1">
                        <img src={bioIcon} className="ms-1 mb-1" alt="" style={{ width: "20px" }} />
                        <p className="fs-14 fw-600 ms-2 mb-0 text-white">Bio</p>
                      </span>
                      <p
                        className="bio-ContentSetting fs-14 fw-normal text-white-50 rounded-10 mb-1"
                        style={{
                          textAlign: "justify",
                          overflowWrap: "break-word",
                          height: "110px",
                        }}
                      >
                        {ellipsis(el.bio, 100)}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        });
        return (
          <div className="row justify-content-center px-3">
            <h1 className="fs-20 fs-lg-24 fw-bold text-white">Organizations</h1>
            {this.createOrganizationBtn()}
            <p className="fs-14 fs-lg-18 fw-500 text-white-50">
              {requiredObject.INFORMATION_TEXT?.CLAN_ORG?.ORG_DESCRIPTION}
            </p>
            {organizations}
          </div>
        );
      }
    }
  };

  render() {
    const OrganizationsList = this.getOrganizationsList();
    return (
      <div>
        <section className="body-section organization-page">
          <div className="container p-3 mt-1 mt-lg-5">{OrganizationsList}</div>
        </section>
        <Modal show={this.state.discordModal} centered dialogClassName="accept-invite-modal">
          <Modal.Body>
            <ConfirmationModal
              confirm={this.state.confirm}
              onClickOpenConfirm={() => {
                this.setState({ discordModal: false });
              }}
              confirmed={() => {
                this.props.history.push("/profile");
              }}
            />
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default Organization;
